export const BASE_URL = 'project-stages';
